import { Component } from '@angular/core';

@Component({
    templateUrl: '419.component.html'
})
export class P419ErrorComponent {
    constructor() { }

}
